import { ARTICLE_NUMBER_PER_PAGE, apiUri } from '../appConfig';

const videoList = (from = 0, count = ARTICLE_NUMBER_PER_PAGE) => (
	fetch(`${apiUri}/video?from=${from}&take=${count}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default videoList;



// WEBPACK FOOTER //
// ./src/js/request/videoList.js